<template>
  <div>
    <div style="overflow-x: auto; overflow-y: hidden">
      <div style="width: fit-content; min-width: 100%">
        <v-card elevation="0" class="rounded-lg primary--text" height="47">
          <div class="text-center d-flex align-center" style="height: 100%">
            <div class="text-start ps-6" style="width: 250px">
              {{ $t("reports.feedback.date") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("reports.employee") }}
            </div>
            <div class="text-start" style="width: 250px">
              {{ $t("course.trainer") }}
            </div>
            <div
              style="width: 250px"
              v-for="(val, index) in questionAnswers"
              :key="index"
            >
              {{ $t("reports.feedback.question") + " " + (index + 1) }}
            </div>
          </div>
        </v-card>
      </div>

      <div v-if="loading && !feedbackReports.length">
        <v-progress-circular indeterminate color="primary">
        </v-progress-circular>
      </div>
      <div v-else-if="!loading && feedbackReports.length">
        <div
          v-for="(feedback, index) in feedbackReports"
          :key="index"
          class="pt-5"
          style="width: fit-content; min-width: 100%"
        >
          <v-card elevation="0" class="rounded-lg textLight--text">
            <div
              class="text-center d-flex align-center"
              style="min-height: 65px"
            >
              <div class="text-start ps-6 text-ellipse-2" style="width: 250px">
                {{
                  feedback && feedback.startDate
                    ? moment(parseInt(feedback.startDate)).format("DD MMM YYYY")
                    : " - "
                }}
              </div>
              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  feedback &&
                  feedback.employee &&
                  feedback.employee.user &&
                  feedback.employee.user.firstName
                    ? `${feedback.employee.user.firstName || ""} ${
                        feedback.employee.user.lastName || ""
                      }`
                    : " - "
                }}
              </div>
              <div class="text-start text-ellipse-2" style="width: 250px">
                {{
                  feedback &&
                  feedback.trainer &&
                  feedback.trainer.user &&
                  feedback.trainer.user.firstName
                    ? `${feedback.trainer.user.firstName || ""} ${
                        feedback.trainer.user.lastName || ""
                      }`
                    : " - "
                }}
              </div>
              <div
                class="text-center text-ellipse-2"
                style="width: 250px"
                v-for="(val, index) in questionAnswers"
                :key="index"
              >
                {{
                  getRatingOrDescriptiveAnswer(
                    val,
                    feedback.feedback.questionAnswers
                  )
                }}
              </div>
            </div>
          </v-card>
        </div>
      </div>
      <div
        v-else-if="!loading && !feedbackReports.length"
        class="textLight--text font-weight-medium"
        align="center"
      >
        {{ $t("noItems") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    feedbackReports: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: true,
      type: Boolean,
    },
    training: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      questionAnswers: [],
    };
  },
  watch: {
    training: {
      immediate: true,
      handler() {
        this.questionAnswers = this.training?.feedback?.questionAnswers
          ? [...this.training.feedback.questionAnswers]
          : [];
        // this.questionAnswers.sort((a, b) => {
        //   if (a.isDescriptive === false) return -1;
        //   else return 1;
        // });
      },
      deep: true,
    },
  },
  methods: {
    getRatingOrDescriptiveAnswer(trainingFeedBack, val) {
      let findVal = val.find(obj => obj.questionId === trainingFeedBack._id);
      if (findVal?.isDescriptive) return findVal?.givenDescriptiveAnswer;
      else return findVal?.givenRating;
    },
  },
};
</script>
